import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import getters from './getters'
import user from './modules/system/user'
import notification from './modules/system/notification'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
let state = {
  cur: 0
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  modules: {
    user, notification
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js